import React, { useState, useEffect, useRef, useMemo } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button, Modal, Col, Row, Form as FormB } from 'react-bootstrap'
import FormField from 'components/FormField'
import { Field, Form, Formik } from 'formik'
import { logger } from 'actions'
import { editCountry, addCountry } from 'actions/rolzoLocations'
import * as Yup from 'yup'
import { requiredStringValidator, stringValidator } from 'form-validation'
import { rolzoCountriesInitialVals } from 'models/rolzoLocations'

const { Row: FormRow } = FormB

const RolzoCountryModal = ({
  show,
  onHide,
  editCountry,
  addCountry,
  isEdit,
  countryId,
  countryInfo,
  ...props
}) => {
  const onClose = () => {
    onHide()
  }

  const countryValidationSchema = Yup.object().shape({
    country: requiredStringValidator(),
    countryCode: requiredStringValidator(),
    region: stringValidator(),
  })

  const initialValues = countryInfo
    ? new rolzoCountriesInitialVals(countryInfo)
    : countryValidationSchema.cast()

  const onSubmit = async (values, form) => {
    try {
      let res = null
      if (isEdit) {
        res = await editCountry(values, countryId)
      } else {
        res = await addCountry(values)
      }

      if (res) {
        onHide()
      }
    } catch (error) {
      console.log('onSubmit error', error)
      logger({ fileName: 'add country', error: error })
    } finally {
      form.setSubmitting(false)
    }
  }

  return (
    <Modal
      size='lg'
      show={show}
      onHide={onClose}
      className='dispatch-booking-modal modal-90w'
      dialogClassName='modal-90w '
      aria-labelledby='contained-modal-title-vcenter'
      centered
      id={'modal'}
    >
      <Modal.Header>
        <Modal.Title id='example-modal-sizes-title-lg' className='modal-title'>
          <>
            <Row className='d-flex align-items-center'>
              <Col>
                <div>
                  <h1
                    className='dispatch-title mb-0 pb-0'
                    style={{
                      paddingLeft: '17px',
                      paddingTop: '24px',
                      fontSize: '24px',
                    }}
                  >
                    {isEdit ? 'Edit' : 'Add'} country
                  </h1>
                  <Button
                    variant='link'
                    className=''
                    onClick={onClose}
                    style={{ marginRight: '22px' }}
                  >
                    <img src='/images/icons/close-icon-black.png' alt='' />
                  </Button>
                </div>
              </Col>
            </Row>
          </>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ paddingTop: '12px' }}>
        <Formik
          {...props}
          onSubmit={onSubmit}
          enableReinitialize={true}
          validationSchema={countryValidationSchema}
          validateOnBlur={true}
          initialValues={initialValues}
        >
          {({ values, isSubmitting, setFieldValue, isValid }) => {
            const fields = [
              {
                name: 'country',
                label: 'Country name*',
                md: 4,
              },
              {
                name: 'countryCode',
                label: 'Country code*',
                md: 4,
              },
              {
                name: 'region',
                label: 'Region',
                md: 4,
              },
            ]
            return (
              <Form noValidate style={{ padding: '24px', marginTop: '20px' }}>
                {fields && fields.length && (
                  <FormRow>
                    {fields.map(
                      (
                        {
                          component = FormField,
                          md = 6,
                          className = '',
                          ...field
                        },
                        f
                      ) => (
                        <>
                          <Col
                            key={String(f)}
                            md={md}
                            className={className || ''}
                          >
                            <Field component={component} {...field} />
                          </Col>
                        </>
                      )
                    )}
                  </FormRow>
                )}
                <div className='add-partner-submit'>
                  <Button
                    className='outsource-btn-partner select-vehicle'
                    style={{ width: '130px' }}
                    onClick={() => {
                      onHide()
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    className='select-btn h-40 share ml-3 mr-0'
                    style={{ width: '130px', height: '35px' }}
                    variant='brown'
                    type='submit'
                    disabled={isSubmitting || !isValid}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default withRouter(
  connect(null, { logger, editCountry, addCountry })(RolzoCountryModal)
)
